import Vue from 'vue';
import kebabCase from 'lodash/kebabCase';

/** Responsible to register package components. */
class ComponentsRegistrator
{
    constructor()
    {
        /** Available component names. */
        this.components = [];
    }
    
    /** Registering all components to vue. */
    register()
    {
        const requireComponent = require.context(
            '~spa/components',
            true,
            /[A-Z]\w+.(vue|js)$/
        );

        requireComponent.keys().filter(key => {
            return key.startsWith('@deegital/trustup-spa-js-assets/components');
        }).forEach(fileName => {
            // Get component config
            const componentConfig = requireComponent(fileName);
        
            var cleanFileName = kebabCase( fileName.replace('@deegital/trustup-spa-js-assets/components', '') );
            var componentName = `v-spa-${cleanFileName}`.replace('v-spa-partials-', 'v-spa-').replace('v-spa-form-', 'v-spa-').replace('-vue', '');
        
            // // Register component globally
            Vue.component(
                componentName,
                // Look for the component options on `.default`, which will
                // exist if the component was exported with `export default`,
                // otherwise fall back to module's root.
                componentConfig.default || componentConfig
            );
        
            this.components.push(componentName);
        });
    }
    
    /** Showing availalble components details.  */
    details()
    {
        console.log('SPA components available :', this.components);
    }
}

const registrator = new ComponentsRegistrator();

export default registrator;